import { render, staticRenderFns } from "./InstructionInfoSlotButton.vue?vue&type=template&id=0700cde5&"
import script from "./InstructionInfoSlotButton.vue?vue&type=script&lang=js&"
export * from "./InstructionInfoSlotButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports